import { render, staticRenderFns } from "./AssignTagOnAccountSDData.vue?vue&type=template&id=5f308a18&scoped=true"
import script from "./AssignTagOnAccountSDData.vue?vue&type=script&lang=js"
export * from "./AssignTagOnAccountSDData.vue?vue&type=script&lang=js"
import style0 from "./AssignTagOnAccountSDData.vue?vue&type=style&index=0&id=5f308a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f308a18",
  null
  
)

export default component.exports